/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_LearnedInputs */



/**
* | output |
* | --- |
* | "Parameters this server refused" |
*
* @param {Private_Models_Connection_LearnedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_learned = /** @type {((inputs?: Private_Models_Connection_LearnedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_LearnedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Parameter, die dieser Server abgelehnt hat")
	return /** @type {LocalizedString} */ ("Parameters this server refused")
});